import { render, staticRenderFns } from "./AppSelectField.vue?vue&type=template&id=0fe04074&"
import script from "./AppSelectField.vue?vue&type=script&lang=js&"
export * from "./AppSelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports